import { Button } from '@mui/material';
import styled from 'styled-components';

const FooterContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  box-shadow: -5px -4px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  min-height: 68px;
  padding: 8px 32px;
  z-index: 1200;
`;

const FooterContentWrapper = styled.div`
  margin-right: auto;
  display: flex;
  align-items: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const StickyFooter = (props: any) => {
  const { buttonList = [], footerContent } = props;
  return (
    <FooterContainer>
      {footerContent && <FooterContentWrapper>{footerContent}</FooterContentWrapper>}
      <ButtonGroup>
      {buttonList.map((button: any, index: number) => (
        <Button
          key={index}
          variant={button.style?.variant || 'contained'}
          size={button.style?.size || 'medium'}
          sx={{
            ...(button.disabled
              ? {
                  backgroundColor: 'transparent !important',
                  border: '1px solid rgb(179, 179, 179) !important',
                  cursor: 'not-allowed',
                  color: '#808080',
                }
              : button.style?.variant === 'outlined'
              ? {
                  backgroundColor: 'transparent',
                  border: '2px solid #002677 !important',
                  borderColor: '#002677',
                  cursor: 'pointer',
                  color: '#002677',
                  ':hover': {
                    backgroundColor: '#002677',
                    borderWidth: '14px',
                    borderColor: '#002677',
                    cursor: 'pointer',
                    color: '#ffffff',
                  },
                  ':hover::after': {
                    content: '""',
                    position: 'absolute',
                    top: -7,
                    left: -7,
                    right: -7,
                    bottom: -7,
                    border: '3px solid #002677',
                    borderRadius: '28px',
                  },
                }
              : {
                  backgroundColor: '#002677',
                  border: 'none',
                  borderColor: '#002677',
                  cursor: 'pointer',
                  color: '#ffffff',
                  ':hover': {
                    backgroundColor: '#002677',
                    borderWidth: '14px',
                    borderColor: '#002677',
                    cursor: 'pointer',
                    color: '#ffffff',
                  },
                  ':hover::after': {
                    content: '""',
                    position: 'absolute',
                    top: -5,
                    left: -5,
                    right: -5,
                    bottom: -5,
                    border: '3px solid #002677',
                    borderRadius: '28px',
                  },
                }),
            fontFamily:
              button.style?.fontFamily || 'Optum Sans, ui-sans-serif, system-ui, -apple-system, Segoe UI, sans-serif',
            textTransform: 'none',
            fontSize: button.style?.fontSize || '16px',
            fontWeight: button.style?.fontWeight || '400',
            gap: button.style?.gap || '16px',
            marginRight: button.style?.marginRight || 1,
            alignItems: 'center',
            borderRadius: button.style?.borderRadius || '24px',
          }}
          onClick={button.onClick}
          disabled={button.disabled || false}
        >
          {button.label}
        </Button>
      ))}
      </ButtonGroup>
    </FooterContainer>
  );
};
